module.exports = __webpack_public_path__ + "static/api_key-9e35f20aa4c8ade0f1606493f673a2e5.png";